import { PushPreview } from "../pushDetail/style/pushDetail";

interface props {
  pushTitle: string;
  pushText: string;
}
const Preview = ({ pushTitle, pushText }: props) => {
  return (
    <>
      <PushPreview>
        <div className="iphone phone">
          <span>IPHONE</span>
          <img src="/image-web/push/iphone.png" alt="아이폰 이미지" />
          <div className="pushBox">
            <div className="pushIcon">
              <img src="/image-web/push/pushIcon.png" alt="push icon" />
            </div>
            <div className="pushBoxContent">
              {pushTitle}
              <span>{pushText}</span>
            </div>
          </div>
        </div>
        <div className="android phone">
          <span>Android</span>
          <img src="/image-web/push/android.png" alt="안드로이드폰 이미지" />
          <div className="pushBox">
            <div className="pushApp">
              <div className="pushIcon">
                <img src="/image-web/push/pushIcon.png" alt="push icon" />
              </div>
              <span>RUNNER RUNNER</span>
            </div>
            <div className="pushBoxContent">
              {pushTitle}
              <span>{pushText}</span>
            </div>
          </div>
        </div>
        <div className="previewGuide">
          <span className="previewGuideTitle">기기 미리보기</span>
          <span>
            이 미리보기는 휴대기기에서 메시지가 어떻게 표현될지 <br />
            대략적으로 보여줍니다. <br />
            실제 렌더링은 기기에 따라 달라집니다.
          </span>
        </div>
      </PushPreview>
    </>
  );
};

export default Preview;
